import { Controller } from "@hotwired/stimulus"

// The sidebar's "Neuerungen" entry (Sidebar::FooterComponent). Opening it submits a PATCH in a
// new tab that marks the newest release as seen and forwards to the release site; this page
// stays put, so its "new" markers (the dot on the help button, the pill beside the entry, and
// lazy frames still loading one) are removed here instead of lingering until the next visit.
export default class extends Controller {
  seen() {
    document.querySelectorAll("[data-release-notes-marker]").forEach((marker) => marker.remove())
  }
}
